module.exports = __webpack_public_path__ + "img/sejong_gallery4.467a2044.jpg";